module.exports = __webpack_public_path__ + "img/16.fcee1cda.jpg";